const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/schedulingPlan.ts';
import { createPatapiCall, HttpMethod } from 'App/utils/fetchUtils';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';

export const REQUEST_ACTION_TYPES_LOAD_SCHEDULING_PLANS = kisapiActionTypes('PATAPP_LOAD_SCHEDULING_PLANS');

export function loadSchedulingPlans() {
    const endpoint = `appointments/plans`;
    return createPatapiCall(REQUEST_ACTION_TYPES_LOAD_SCHEDULING_PLANS, endpoint, HttpMethod.GET);
}
